import React, { useEffect, useState } from "react";
import { Table, OverlayTrigger, Tooltip, Badge } from "react-bootstrap";
import { MdOutlineSort, MdWarningAmber } from "react-icons/md";
import { FiInfo } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaAnomalie = () => {
  const [anomalie, setAnomalie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: "data_rimesso",
    direction: "desc",
  });

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnomalie = data?.ANOMALIE || [];
        setAnomalie(arrayAnomalie.flat());
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...anomalie].sort((a, b) => {
      const valA = a[key] ? a[key].toString().toLowerCase() : "";
      const valB = b[key] ? b[key].toString().toLowerCase() : "";

      if (!isNaN(parseFloat(valA)) && !isNaN(parseFloat(valB))) {
        return direction === "asc"
          ? parseFloat(valA) - parseFloat(valB)
          : parseFloat(valB) - parseFloat(valA);
      }

      if (valA < valB) return direction === "asc" ? -1 : 1;
      if (valA > valB) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setAnomalie(sortedData);
  };

  const formatData = (dateStr) => {
    if (!dateStr) return "-";
    const soloData = dateStr.split(" ")[0];
    return soloData.split("-").reverse().join("/");
  };

  const getStatusStyle = (dateStr) => {
    if (!dateStr) return { borderLeft: "4px solid #dee2e6" };
    const dataRimesso = new Date(dateStr.split(" ")[0]);
    const oggi = new Date();
    const diffDays = Math.floor((oggi - dataRimesso) / (1000 * 60 * 60 * 24));

    if (diffDays >= 15)
      return { borderLeft: "4px solid #dc3545", backgroundColor: "#fff5f5" };
    if (diffDays >= 7)
      return { borderLeft: "4px solid #fd7e14", backgroundColor: "#fffaf5" };
    if (diffDays >= 3)
      return { borderLeft: "4px solid #ffc107", backgroundColor: "#fffdf5" };

    return { borderLeft: "4px solid #198754" };
  };

  const renderTooltip = (props) => (
    <Tooltip id="info-anomalie-tooltip" {...props}>
      <div style={{ textAlign: "left", fontSize: "0.75rem", padding: "5px" }}>
        <strong>Legenda Colori:</strong>
        <br />• <span style={{ color: "#dc3545" }}>Rosso</span>: Ritardo &gt;
        15gg
        <br />• <span style={{ color: "#fd7e14" }}>Arancio</span>: Ritardo &gt;
        7gg
        <br />• <span style={{ color: "#ffc107" }}>Giallo</span>: Ritardo &gt;
        3gg
        <br />• <span style={{ color: "#198754" }}>Verde</span>: Recente
      </div>
    </Tooltip>
  );

  return (
    <div
      className="shadow-sm card"
      style={{
        borderRadius: "16px",
        border: "1px solid #eee",
        height: "380px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      {/* Header Widget */}
      <div className="p-3 bg-white border-bottom d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <span
            style={{
              fontWeight: "800",
              fontSize: "0.75rem",
              color: "#1a1a1a",
              letterSpacing: "1px",
              marginRight: "8px",
            }}
          >
            ANOMALIE RILEVATE
          </span>
          <OverlayTrigger
            placement="right"
            delay={{ show: 100, hide: 400 }}
            overlay={renderTooltip}
          >
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <FiInfo size={14} color="#adb5bd" />
            </span>
          </OverlayTrigger>
        </div>
        <Badge
          pill
          bg="warning"
          text="dark"
          style={{ fontSize: "0.65rem", fontWeight: "700" }}
        >
          <MdWarningAmber className="me-1" /> {anomalie.length} ALERT
        </Badge>
      </div>

      <style>{`
.scroll-area { 
  overflow-y: auto; 
  overflow-x: hidden;
  flex-grow: 1; 
  background: #fff; 
}        .table-anomalie { margin-bottom: 0; }
        .table-anomalie thead th { 
            position: sticky; top: 0; z-index: 10; 
            background-color: #f8f9fa !important; color: #495057 !important; 
            font-size: 0.65rem; text-transform: uppercase; padding: 12px 10px;
            border-bottom: 1px solid #dee2e6 !important;
            cursor: pointer; transition: background 0.2s;
        }
        .table-anomalie thead th:hover { background-color: #e9ecef !important; }
        .table-anomalie tbody td { 
            font-size: 0.75rem; padding: 12px 10px; 
            vertical-align: middle; border-bottom: 1px solid #f8f9fa;
        }
        .sort-icon { font-size: 0.85rem; color: #ced4da; margin-left: 4px; }
        .row-hover:hover { background-color: #f8f9ff !important; }
      `}</style>

      <div className="scroll-area">
        <Table hover className="table-anomalie border-0">
          {" "}
          <thead>
            <tr>
              {[
                { label: "Causale", key: "causale" },
                { label: "Ragione Sociale", key: "ragione_sociale" },
                { label: "Data Rim.", key: "data_rimesso" },
                { label: "Num. Rim", key: "numero_rimesso" },
                { label: "Dep", key: "deposito" },
                { label: "Articolo", key: "articolo" },
                { label: "Qta", key: "quantita" },
                { label: "Compl.", key: "data_completamento_bem" },
              ].map((col) => (
                <th key={col.key} onClick={() => requestSort(col.key)}>
                  {col.label} <MdOutlineSort className="sort-icon" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="text-center py-5 text-muted small">
                  Scansione in corso...
                </td>
              </tr>
            ) : (
              anomalie.map((item, index) => {
                const statusStyle = getStatusStyle(item.data_rimesso);
                return (
                  <tr key={index} className="row-hover">
                    <td style={statusStyle}>
                      <span
                        className="text-truncate d-block"
                        style={{
                          maxWidth: "100px",
                          fontWeight: "600",
                          fontSize: "0.65rem",
                        }}
                        title={item.causale}
                      >
                        {item.causale}
                      </span>
                    </td>
                    <td className="fw-bold text-dark">
                      {item.ragione_sociale}
                    </td>
                    <td>{formatData(item.data_rimesso)}</td>
                    <td>
                      <small className="text-muted">#</small>
                      {item.numero_rimesso?.replace(/,$/, "")}
                    </td>
                    <td className="text-center">{item.deposito}</td>
                    <td className="text-primary fw-medium">{item.articolo}</td>
                    <td className="text-center fw-bold">
                      {Math.round(item.quantita)}
                    </td>
                    <td className="text-muted">
                      {formatData(item.data_completamento_bem)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TabellaAnomalie;
